import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { USER_ROLE } from 'src/app/shared/models/user';

@Pipe({
    name: 'missionLogType',
    pure: true,
    standalone: false
})
export class MissionLogTypePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(row: any, role: USER_ROLE, ...args: unknown[]): string {
    let value = this.translateService.instant('modules.mission.mission_log_grid.event_type.' + row.type);
    if (row.note && !(row.note.startsWith('#') && row.note.endsWith('#') && role !== USER_ROLE.ADMIN)) {
      value += ' (' + row.note + ')';
    }
    return value;
  }
}